const API = process.env.REACT_APP_API_URL || '';
const BASE = `${API}/api/materials-review`;

async function parse(res) {
  try { return await res.json(); } catch { return { success: false, message: 'No answer from the server' }; }
}
export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, { method, credentials: 'include', headers: body ? { 'Content-Type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined });
  return parse(res);
}
export async function apiUpload(path, formData) {
  const res = await fetch(`${BASE}${path}`, { method: 'POST', credentials: 'include', body: formData });
  return parse(res);
}
export const fileUrl = (materialId, versionId, inline = true) => `${BASE}/materials/${materialId}/versions/${versionId}/file${inline ? '?inline=1' : ''}`;
export const recordUrl = (materialId, fmt) => `${BASE}/materials/${materialId}/record.${fmt}`;

export function fmtDay(d) {
  if (!d) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d));
  const dt = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(d);
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
export function fmtWhen(d) { return d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''; }

export const STATUS_WORDS = {
  draft: 'Draft', in_review: 'In review', returned: 'Returned', approved: 'Approved', submitted: 'Submitted', accepted: 'Accepted by CMS', disapproved: 'Disapproved', in_use: 'In use', retired: 'Retired', withdrawn: 'Withdrawn',
};
export const STATUS_TONE = {
  draft: 'bg-slate-100 text-slate-700 ring-slate-200', in_review: 'bg-amber-50 text-amber-800 ring-amber-200', returned: 'bg-rose-50 text-rose-700 ring-rose-200', approved: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  submitted: 'bg-blue-50 text-blue-700 ring-blue-200', accepted: 'bg-emerald-50 text-emerald-700 ring-emerald-200', disapproved: 'bg-rose-50 text-rose-700 ring-rose-200', in_use: 'bg-emerald-50 text-emerald-800 ring-emerald-200', retired: 'bg-slate-100 text-slate-500 ring-slate-200', withdrawn: 'bg-slate-100 text-slate-500 ring-slate-200',
};
export const ROLE_WORDS = { marketing: 'Marketing', compliance: 'Compliance', um: 'Utilization Management', appeals: 'Appeals and Grievances', enrollment: 'Enrollment', claims: 'Claims', provider_relations: 'Provider Relations' };
export const AUDIENCE_WORDS = { members: 'Current members', prospects: 'Prospective members', providers: 'Providers' };
export const PATH_WORDS = { unknown: 'Not decided yet', none: 'Not submitted to HPMS', file_and_use: 'HPMS file and use, five days', review: 'HPMS review, 45 days', review_model: 'HPMS, standardized or model marketing, ten days', submitted_not_reviewed: 'HPMS, submitted not reviewed' };
export const CLASS_WORDS = { required: 'Required', standardized: 'Standardized', model: 'Model', integrated: 'Integrated', plan_written: 'Plan written' };
export const FIELD_WORDS = { marketing_or_communication: 'Marketing or communication', medicaid_content: 'Medicaid content', material_class: 'Material class', material_type: 'Material type', part_c_d: 'Part C and Part D', language: 'Language', medicaid_reasons: 'Why it is Medicaid marketing' };
const LANG_WORDS = { en: 'English', es: 'Spanish', ht: 'Haitian Creole', other: 'Other' };
/** The plain words for a fact's value: the HPMS label for a type, the class word, Yes or No, the language name. */
export function labelFor(field, value, lookups = []) {
  const v = valueText(value);
  if (field === 'material_type') return lookups.find((l) => l.kind === 'material_type' && l.code === v)?.label || v;
  if (field === 'material_class') return CLASS_WORDS[v] || v;
  if (field === 'medicaid_content' || field === 'part_c_d') return v === 'yes' || v === 'true' ? 'Yes' : v === 'no' || v === 'false' ? 'No' : v;
  if (field === 'marketing_or_communication') return v === 'marketing' ? 'Marketing' : v === 'communication' ? 'Communication' : v;
  if (field === 'language') return lookups.find((l) => l.kind === 'language' && l.code === v)?.label || LANG_WORDS[v] || v;
  return v;
}
/** Keep the open material in the address so a reload comes back to it. */
export function setMaterialInUrl(id) {
  try {
    const u = new URL(window.location.href);
    if (id) u.searchParams.set('material', id); else u.searchParams.delete('material');
    window.history.replaceState(window.history.state, '', u.toString());
  } catch { /* the address is a convenience */ }
}
export function materialFromUrl() { try { return new URLSearchParams(window.location.search).get('material') || null; } catch { return null; } }
export const SEVERITY_TONE = { block: 'bg-rose-50 text-rose-700 ring-rose-200', fix: 'bg-amber-50 text-amber-800 ring-amber-200', note: 'bg-slate-100 text-slate-600 ring-slate-200' };
export const SEVERITY_WORDS = { block: 'Must fix', fix: 'Fix', note: 'Note' };

export function valueText(v) {
  if (v == null) return '';
  if (typeof v === 'string') { try { const j = JSON.parse(v); return valueText(j); } catch { return v; } }
  if (Array.isArray(v)) return v.map((x) => (x && typeof x === 'object' ? x.label || x.code || JSON.stringify(x) : String(x))).join(', ');
  if (typeof v === 'object') return v.label || v.code || JSON.stringify(v);
  return String(v);
}
